const TaskAndFastenerMatcher = (tasksAndBoltsIdsAndFasteners) => {
  if (tasksAndBoltsIdsAndFasteners?.length === 0) {
    return {
      $match: {},
    };
  } else {
    return {
      $match: {
        idAndFastener: {
          $in: tasksAndBoltsIdsAndFasteners,
        },
      },
    };
  }
};

export default TaskAndFastenerMatcher;
